import { css, html, LitElement, svg } from 'lit'
import { property } from 'lit/decorators.js'
import { unsafeSVG } from 'lit/directives/unsafe-svg.js'
import { safeCustomElement } from '@/utilities/custom-element'
import { iconMap } from './icon-sprite'
import type { IconName, IconSize } from './types'

@safeCustomElement('mdc-icon')
export class MdcIcon extends LitElement {
  @property({ type: String }) name?: IconName
  @property({ type: String, reflect: true }) size: IconSize = 'md'

  static styles = css`
		:host {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 0;
			width: 1rem;
			height: 1rem;
			color: inherit;
			font-family: var(--typography-font-family-sans);
		}

		:host([size='sm']) {
			width: 0.75rem;
			height: 0.75rem;
		}

		:host([size='md']) {
			width: 1rem;
			height: 1rem;
		}

		:host([size='lg']) {
			width: 1.5rem;
			height: 1.5rem;
		}

		svg {
			width: 100%;
			height: 100%;
			display: block;
		}
	`

  render() {
    if (!this.name) {
      return null
    }

    const iconData = iconMap[this.name]
    if (!iconData) {
      return null
    }

    const content = iconData.content.replaceAll('fill="#111111"', 'fill="currentColor"')

    return html`${svg`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="${iconData.viewBox}" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
        ${unsafeSVG(content)}
      </svg>
    `}`
  }
}
